import { Component, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';

import { AlertService } from '../_services/alert.service';
import { Alert, AlertType } from '../_models/alert';

@Component({
    moduleId: module.id,
    selector: 'app-alert',
    templateUrl: 'alert.component.html',
    styleUrls: ['alert.component.css']
})

export class AlertComponent implements AfterViewChecked {
    @ViewChild('growl') growl: ElementRef;

    alerts = [];

    constructor(
        private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getAlert().subscribe((alert: Alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            let idx = this.checkIfExists(alert);

            // add alert to array
            if (idx < 0) {
                this.alerts.push({ n: 1, alert: alert });
            } else {
                this.alerts[idx].n = this.alerts[idx].n + 1;
            }
        });

        window.addEventListener("scroll", () => {
            this.ngAfterViewChecked()
        });
    }

    checkIfExists(alert) {

        let idx = this.alerts.findIndex(o => (o.alert.type == alert.type) && (o.alert.customData == alert.customData))

        return idx;
    }

    ngAfterViewChecked() {
        if (this.growl) {
            if (window.scrollY > 70) {
                this.growl.nativeElement.className = ("growl-message-box show");
            } else {
                this.growl.nativeElement.className = ("growl-message-box hide");
            }
        }
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x.alert !== alert);
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success';
            case AlertType.Error:
                return 'alert alert-danger';
            case AlertType.Info:
                return 'alert alert-info';
            case AlertType.Warning:
                return 'alert alert-warning';
        }
    }

    getMessage(al) {
        return (al.n > 1 ? '[' + al.n + '] ' : '') + al.alert.message;
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/alert/alert.component.ts